import React from "react";
import "./aboutpage.css";
function AboutCarousel() {
  return (
    <div className="skills_Container">
      <h2>Skills</h2>
      <div className="carousel">
        <div className="carousel-content">
          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg"
            height="40"
            alt="html5 logo"
          />
          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg"
            height="40"
            alt="css3 logo"
          />
          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
            height="40"
            alt="javascript logo"
          />
          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg"
            height="40"
            alt="react logo"
          />
          <img
            src="https://cdn.simpleicons.org/tailwindcss/06B6D4"
            height="40"
            alt="tailwindcss logo"
          />

          <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nextjs/nextjs-original.svg" />

          <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/firebase/firebase-original.svg" />

          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/qt/qt-original.svg"
            height="40"
            alt="qt logo"
          />
          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg"
            height="40"
            alt="cplusplus logo"
          />

          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg"
            height="40"
            alt="figma logo"
          />

          <img
            src="https://skillicons.dev/icons?i=ps"
            height="40"
            alt="adobephotoshop logo"
          />

          <img
            src="https://skillicons.dev/icons?i=ai"
            height="40"
            alt="adobeillustrator logo"
          />
          <img
            src="https://skillicons.dev/icons?i=pr"
            height="40"
            alt="adobepremierepro logo"
          />

          <img
            src="https://skillicons.dev/icons?i=ae"
            height="40"
            alt="adobeaftereffects logo"
          />

          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg"
            height="40"
            alt="nodejs logo"
          />

          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/materialui/materialui-original.svg"
            height="40"
            alt="materialui logo"
          />
        </div>
        <div className="carousel-content">
          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg"
            height="40"
            alt="html5 logo"
          />
          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg"
            height="40"
            alt="css3 logo"
          />
          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
            height="40"
            alt="javascript logo"
          />
          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg"
            height="40"
            alt="react logo"
          />
          <img
            src="https://cdn.simpleicons.org/tailwindcss/06B6D4"
            height="40"
            alt="tailwindcss logo"
          />

          <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nextjs/nextjs-original.svg" />

          <img src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/firebase/firebase-original.svg" />

          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/qt/qt-original.svg"
            height="40"
            alt="qt logo"
          />
          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg"
            height="40"
            alt="cplusplus logo"
          />

          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg"
            height="40"
            alt="figma logo"
          />

          <img
            src="https://skillicons.dev/icons?i=ps"
            height="40"
            alt="adobephotoshop logo"
          />

          <img
            src="https://skillicons.dev/icons?i=ai"
            height="40"
            alt="adobeillustrator logo"
          />
          <img
            src="https://skillicons.dev/icons?i=pr"
            height="40"
            alt="adobepremierepro logo"
          />

          <img
            src="https://skillicons.dev/icons?i=ae"
            height="40"
            alt="adobeaftereffects logo"
          />

          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg"
            height="40"
            alt="nodejs logo"
          />

          <img
            src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/materialui/materialui-original.svg"
            height="40"
            alt="materialui logo"
          />
        </div>
      </div>
    </div>
  );
}

export default AboutCarousel;
